import theme from '@styles/theme';
export default {
  descriptionArea: (isSmall = false) => ({
    position: 'relative',
    p: isSmall ? '8px 16px 24px' : ['8px 16px 24px', '8px 16px 24px', '8px 16px 24px', '16px 16px 40px']
  }),
  descriptionSkeletonContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: theme.zIndex.documentHigh,
    bg: theme.rawColors.neutralWhite,
    p: '8px 16px 24px'
  },
  infoNameSkeleton: {
    mb: '4px'
  },
  infoPriceSkeleton: {
    mb: '4px'
  },
  infoColorSkeleton: {
    mr: 'calc(1rem / 4)'
  }
};